import React, { forwardRef, useImperativeHandle, useState, useEffect, ReactNode } from 'react';
import { Dropdown } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { FeatureGuard } from '../../components/multi-tenant/FeatureGuard';
import { AnyType } from '../../interfaces';
import { ServiceRequestType } from '../../hooks/use-bv-summary';

export interface ActionColumnActions {
  featureKey?: string;
  href?: string;
  icon: ReactNode;
  label: string;
  testId?: string;
  data?: any;
  onClick?: () => void;
}

export const ActionsCellRenderer = () => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };
  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className='text-center text-primary'
      data-testid='cmx__hcp-grid-actions-button'>
      <i
        className='fa-regular fa-ellipsis-vertical '
        style={{
          color: 'black',
          border: '1px solid #009B92',
          borderWidth: '1px',
          padding: '8px 13px 8px 13px',
          cursor: 'pointer',
          borderRadius: '4px',
          backgroundColor: isHovered ? '#009B92' : 'transparent', // Change background color on hover
          transition: 'background-color 0.3s ease'
        }}></i>
    </div>
  );
};

export const ActionsCellEditor = forwardRef((props: AnyType, ref) => {
  const [show, setShow] = useState(true);
  const history = useHistory();
  const [hoverIndex, setHoverIndex] = useState<number | null>(null);

  const handleClick = (event: any) => {
    const eventTargetValue = event.target?.offsetParent;
    const svgElementValue = event.srcElement?.parentElement?.id || event.srcElement?.id;
    let className = false;
    if ((event.target && eventTargetValue) || svgElementValue) {
      className =
        (typeof eventTargetValue?.className === 'string' &&
          eventTargetValue?.className.includes('ag-cell-popup-editing')) ||
        svgElementValue === 'cmx__hcp-grid-svg-icon';
    }
    if (show || className) {
      setShow(!show);
    }
  };

  // This will run in all render and handle clicks
  useEffect(() => {
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  });

  useImperativeHandle(ref, () => {
    return {
      getValue() {
        return '';
      },
      isPopup() {
        return true;
      }
    };
  });

  // const onClick = (a: AnyType) => {
  //   history.push(a.href);
  // };

  const onClick = (action: ActionColumnActions) => {
    if (action.href) {
      history.push(action.href);
    } else if (action.onClick) {
      action.onClick(); // Execute custom function like handleClickOpen or resetPassword
    }
  };

  const hoverStyle = {
    backgroundColor: '#f0f0f0' // Change this to your desired hover background color
  };

  const { values } = props;
  const gridItems = values && values(props.node);
  const items = gridItems?.filter((item: ActionColumnActions) => !ServiceRequestType.includes(item?.data?.requestType));

  return (
    <Dropdown drop='start' show={show}>
      <Dropdown.Toggle className='sr-only'>&nbsp;</Dropdown.Toggle>
      <Dropdown.Menu className='px-0' align='start'>
        {items?.map((a: AnyType, index: number) => (
          <FeatureGuard key={a?.label} contentKey={a?.featureKey}>
            <Dropdown.Item
              onMouseLeave={() => setHoverIndex(null)}
              onMouseEnter={() => setHoverIndex(index)}
              className='text-muted'
              data-testid={a.testId}
              style={hoverIndex === index ? hoverStyle : undefined}
              onClick={() => onClick(a)}>
              {a?.icon}
              <span
                style={{ marginLeft: '4px', color: '#212529', fontSize: 16, fontFamily: 'Arial', fontWeight: '400' }}>
                {a?.label}
              </span>
            </Dropdown.Item>
          </FeatureGuard>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
});

ActionsCellEditor.displayName = 'ActionsCellEditor';
